"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Pre = function Pre(props) {
  var className = props.className,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "use"]);
  return _react.default.createElement("pre", Object.assign({}, rest, {
    className: (0, _classnames.default)(className, {
      'private-pre--code': use === 'code'
    })
  }));
};

Pre.propTypes = {
  use: _propTypes.default.oneOf(['default', 'code'])
};
Pre.defaultProps = {
  use: 'default'
};
Pre.displayName = 'Pre';
var _default = Pre;
exports.default = _default;
module.exports = exports.default;